/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Product Card Tariff Field Roaming component
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.10.0
 */

import { fonts } from '@/main/theme';
import { RateplanTooltipIcon } from '@pages/PageProducts/components/ProductCards/RateplanTooltipIcon';

import { BlockWithIcon, TextBlock } from '../../../../../components/common';
import { ProductCardTariffFieldRoamingStyled } from '../styled/ProductCardTariffStyled';


export interface IProductCardTariffFieldRoamingProps {
    tooltip?: string;
    svgIconUrl?: string;
    value: string;
}

const ProductCardTariffFieldRoaming = (props: IProductCardTariffFieldRoamingProps) => {

    const { tooltip, svgIconUrl, value } = props;

    /*
    * -------------------------------------------
    *                 Render
    * -------------------------------------------
    */

    return (
        <ProductCardTariffFieldRoamingStyled>
            <BlockWithIcon iconLeft={svgIconUrl}>
                <TextBlock font={fonts.textMain}>{value}</TextBlock>
            </BlockWithIcon>
            <RateplanTooltipIcon tooltip={tooltip} />
        </ProductCardTariffFieldRoamingStyled>
    );
};

export default ProductCardTariffFieldRoaming;
